import React from "react";
import pengu from "./pengu.jpg";


const UserAvatar = () => {
    return (
        <div>
            <img src={pengu} alt="penguin" />
        </div>

    )
}

export default UserAvatar;